import type { StreamSegmentBoundary } from '../../../../../reducers/aiAssistant.reducers';

export type MessageSegment = { kind: 'text'; text: string } | { kind: 'document' };

/**
 * Splits a message's text at its stream-order boundaries. A 'document' boundary
 * yields a document slot between the surrounding text pieces; a 'round'
 * boundary only splits the text, so each tool round's text renders as its own
 * block. Offsets beyond the given text (paced reveal still catching up) clamp
 * to its end, so a document slot can precede text that is still typing out.
 */
export const splitMessageIntoSegments = (
	text: string,
	boundaries: StreamSegmentBoundary[]
): MessageSegment[] => {
	const segments: MessageSegment[] = [];
	let cursor = 0;

	for (const boundary of boundaries) {
		const end = Math.max(boundary.offset, cursor);
		const piece = text.slice(cursor, end);
		if (piece.trim() !== '') {
			segments.push({ kind: 'text', text: piece });
		}
		if (boundary.kind === 'document') {
			segments.push({ kind: 'document' });
		}
		cursor = end;
	}

	const tail = text.slice(cursor);
	if (tail.trim() !== '') {
		segments.push({ kind: 'text', text: tail });
	}

	return segments;
};
